import { mapState } from 'vuex';
import AddWidgetDialog from './components/addWidgetDialog.vue';
import DashboardParametersDialog from './components/dashboardParametersDialog.vue';
import DashboardWidgetGrid from './components/dashboardWidgetGrid.vue';
import DashboardToolbar from './components/toolbar.vue';
export default {
  name: 'DashboardRenderer',
  components: {
    AddWidgetDialog,
    DashboardParametersDialog,
    DashboardWidgetGrid,
    DashboardToolbar
  },
  props: {
    activeDashboard: {
      type: Object,
      required: false,
      default: null
    },
    actualDateRange: {
      type: Object,
      required: true
    },
    status: {
      type: String,
      required: true
    },
    editMode: {
      type: Boolean,
      required: true
    },
    customParameters: {
      type: Object,
      required: true
    },
    error: {
      type: String,
      required: false,
      default: null
    },
    dashboardLayers: {
      type: Array,
      required: true
    },
    showCloseButton: {
      type: Boolean,
      required: false,
      default: false
    },
    showFullScreenButton: {
      type: Boolean,
      required: false,
      default: false
    },
    widgetMinSize: {
      type: Number,
      required: false,
      default: null
    },
    showEditModeButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      showAddWidgetDialog: false,
      showParametersDialog: false,
      showDefaultDateRangeSaveDialog: false
    };
  },
  computed: {
    ...mapState('app', ['color'])
  },
  watch: {
    actualDateRange: {
      handler() {
        this.refreshWidgetData();
      },
      deep: true
    }
  },
  methods: {
    saveDefaultDateRangeAsAbsolute() {
      this.$emit('save-default-date-range', true);
    },
    saveDefaultDateRangeAsRelative() {
      this.$emit('save-default-date-range', false);
    },
    refreshWidgetData() {
      if (!this.$refs.dashboardWidgetGrid) {
        return;
      }
      this.$refs.dashboardWidgetGrid.refreshData();
    }
  }
};